module.exports = __webpack_public_path__ + "media/images/blog-banner-98120dfc7a7f844506a0203ee8b9e0f3.jpg";